import { $jsonApi } from '#/api/client'

import type { ISearchResults } from '../interfaces'

interface IUseGlobalSearchResponse {
  results: ISearchResults
  isLoading: boolean
  isError: boolean
}

/** Shape returned by the /search endpoint (not yet documented in OpenAPI spec) */
interface ISearchApiUser {
  id?: string
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  companyId?: string | null
  companyName?: string | null
}

interface ISearchApiCompany {
  id?: string
  name?: string | null
}

interface ISearchApiCard {
  id?: string
  engravedId?: string | null
  name?: string | null
  status?: string | null
  companyId?: string | null
  companyName?: string | null
  category?: string | null
}

interface ISearchApiResponse {
  users?: ISearchApiUser[]
  companies?: ISearchApiCompany[]
  cards?: ISearchApiCard[]
}

const EMPTY_RESULTS: ISearchResults = {
  users: [],
  companies: [],
  cards: [],
}

export const useGlobalSearch = (query: string): IUseGlobalSearchResponse => {
  const trimmed = query.trim()

  const { data, isLoading, isError } = $jsonApi.useQuery(
    'get',
    '/search',
    { params: { query: { q: trimmed, limit: 5 } } },
    {
      enabled: trimmed.length >= 2,
      select: (response): ISearchResults => {
        const res = (response ?? {}) as ISearchApiResponse
        return {
          users: (res.users ?? []).map((u: ISearchApiUser) => ({
            id: u.id ?? '',
            firstName: u.firstName ?? null,
            lastName: u.lastName ?? null,
            email: u.email ?? null,
            companyId: u.companyId ?? null,
            companyName: u.companyName ?? null,
          })),
          companies: (res.companies ?? []).map((c: ISearchApiCompany) => ({
            id: c.id ?? '',
            name: c.name ?? null,
          })),
          cards: (res.cards ?? []).map((card: ISearchApiCard) => ({
            id: card.id ?? '',
            engravedId: card.engravedId ?? null,
            name: card.name ?? null,
            status: card.status ?? null,
            companyId: card.companyId ?? null,
            companyName: card.companyName ?? null,
            category: card.category ?? null,
          })),
        }
      },
    },
  )

  return {
    results: data ?? EMPTY_RESULTS,
    isLoading: trimmed.length >= 2 && isLoading,
    isError,
  }
}
